import { Modal, Space,Button } from "antd";
import React, { ReactNode } from "react";

export interface CustomModalProps {
  /**
   * 弹窗标题
   */
  title?: string;
  /**
   * 是否显示弹窗
   */
  open: boolean;
  /**
   * 确认按钮文本
   */
  okText?: string;
  /**
   * 取消按钮文本
   */
  cancelText?: string;
  /**
   * 确认按钮加载状态
   */
  confirmLoading?: boolean;
  /**
   * 点击确定回调
   */
  onOk?: () => void;
  /**
   * 点击取消回调
   */
  onCancel?: () => void;
  /**
   * 弹窗宽度
   */
  width?: number | string;
  /**
   * 是否显示右上角关闭按钮
   */
  closable?: boolean;
  /**
   * 是否点击蒙层关闭
   */
  maskClosable?: boolean;
  /**
   * 底部内容，当不需要默认底部按钮时，可以设为 null
   */
  footer?: ReactNode;
  /**
   * 确认按钮的props
   */
  okButtonProps?: any;
  /**
   * 取消按钮的props
   */
  cancelButtonProps?: any;
  /**
   * 垂直居中展示
   */
  centered?: boolean;
  /**
   * 弹窗内容（插槽）
   */
  children?: ReactNode;
  /**
   * 自定义类名
   */
  className?: string;
  /**
   * 关闭时销毁子元素
   */
  destroyOnClose?: boolean;
}

const CustomModal: React.FC<CustomModalProps> = ({
  title='提示',
  open,
  okText = "确定",
  cancelText = "取消",
  confirmLoading = false,
  onOk,
  onCancel,
  width = 520,
  closable = true,
  maskClosable = false, 
  okButtonProps,
  cancelButtonProps,
  centered = true,
  children,
  className = "",
  destroyOnClose = true,
}) => {
  const footer = (
    <>
        <Space>
            {onCancel && <Button onClick={onCancel} className="btn-2">{cancelText}</Button>}
            {onOk && <Button type="primary"  onClick={onOk}>{okText}</Button>}
        </Space>
    </>
  )
  return (
    <Modal
      title={title}
      open={open}
      onOk={onOk}
      onCancel={onCancel}
      okText={okText}
      cancelText={cancelText}
      confirmLoading={confirmLoading}
      width={width}
      closable={closable}
      maskClosable={maskClosable}
      footer={footer}
      okButtonProps={okButtonProps}
      cancelButtonProps={cancelButtonProps}
      centered={centered}
      className={className} 
    >
      {children}
    </Modal>
  );
};

export default CustomModal;
export { default as ImportModal } from './ImportModal';
